// extracted by mini-css-extract-plugin
export default {"imgContainer":"PopUpComponent_imgContainer__ReOtK","imagenPopup":"PopUpComponent_imagenPopup__eJOnq"};